var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGb = function SvgGb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "M7.6 8.099 3 5.799c-.5.7-.9 1.5-1.2 2.3z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M3.5 5.2 8 7.4V1.9Q5.3 2.95 3.5 5.2",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "m16.4 8.099 4.6-2.3c.5.7.9 1.5 1.2 2.3z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M20.5 5.2 16 7.4V1.9q2.7 1.05 4.5 3.3",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "M7.6 15.9 3 18.2c-.5-.7-.9-1.5-1.2-2.3z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M3.5 18.8 8 16.6v5.5q-2.7-1.05-4.5-3.3",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "m16.4 15.9 4.5 2.3c.5-.7.9-1.5 1.2-2.3z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#012169",
    fillRule: "evenodd",
    d: "M20.5 18.8 16 16.6v5.5q2.7-1.05 4.5-3.3",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#C8102E",
    fillRule: "evenodd",
    d: "M1.4 14.5h8.2v8.1q1.2.3 2.4.3t2.4-.3v-8.1h8.2c.2-.8.3-1.6.3-2.5 0-.8-.1-1.6-.3-2.3h-8.2V1.4q-1.2-.3-2.4-.3t-2.4.3v8.3H1.3c-.2.8-.3 1.5-.3 2.3.1.9.2 1.7.4 2.5",
    clipRule: "evenodd"
  })));
};
export default SvgGb;